/**
 * Reads the live, human-readable value of a Barcode/QR Code field's
 * `source_field`, straight off the current row -- there is nothing cached on
 * the field itself (see `SourceFieldReferenceFieldType` backend docstring),
 * so this always reflects the source field's current cell value.
 *
 * Returns `null` when there's nothing to render yet: no source field
 * configured, the source field was deleted (dangling `source_field_id`), or
 * the row hasn't loaded that field's column (e.g. a partially fetched row).
 */
export function resolveSourceFieldValue($registry, field, row, fields) {
  if (!field.source_field_id || !row) {
    return null
  }

  const sourceField = fields.find((f) => f.id === field.source_field_id)
  if (!sourceField) {
    return null
  }

  const rowFieldKey = `field_${sourceField.id}`
  if (!(rowFieldKey in row)) {
    return null
  }

  const rowValue = row[rowFieldKey]
  const sourceFieldType = $registry.get('field', sourceField.type)
  const humanReadableValue = sourceFieldType.toHumanReadableString(
    sourceField,
    rowValue
  )
  return humanReadableValue || null
}
